import SvgIcon from '@mui/material/SvgIcon';
import styled, { css } from 'styled-components';
const Svg = styled(SvgIcon) `
  ${({ height, width }) => css `
    height: ${height}px;
    width: ${width}px;
  `}
`;
export default Svg;
